import { useEffect } from "react";
import { useAuth} from "react-oidc-context";

export const useSilentRefresh = () => {
  const auth = useAuth();

  useEffect(() => {
    // Subscribe to the addAccessTokenExpiring event
    const cleanup = auth.events.addAccessTokenExpiring(() => {
      console.log("Refreshing token");
      auth.signinSilent().catch(async (error) => {
        const currentPath = window.location.pathname;
        // console.log("currentPath", currentPath);
        // Create a Promise to set the original path in local storage
        const setOriginalPath = new Promise((resolve) => {
          localStorage.setItem("originalPath", currentPath);
          resolve();
        });
        // Wait for the original path to be written to local storage
        await setOriginalPath;
        auth.signinRedirect().catch((error) => {
          console.error("Error during signinRedirect:", error);
        });

        console.error("Silent refresh failed:", error);
      });
    });

    // Clean up the event subscription when the hook is unmounted
    return cleanup;
  }, [auth, auth.events, auth.signinSilent]);
};
